import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getHospitalNotifySelector } from '../selectors'
import { saveHospitalNotify } from '../store/hospitalNotify.actions'
import { HospitalNotifyConstants } from '../store/hospitalNotify.constants'
import { IHospitalNotifyState } from '../store/hospitalNotify.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const hospitalNotifyState: IHospitalNotifyState = yield select(getHospitalNotifySelector)
  const { comments } = hospitalNotifyState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.hospitalNotifyStateList && pcrDoc.patient?.hospitalNotifyStateList.length) {
        const index = pcrDoc.patient?.hospitalNotifyStateList?.findIndex(
          (hospitalNotify) => hospitalNotify.key === hospitalNotifyState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.hospitalNotifyStateList[index].comments !== comments) {
            yield put(saveHospitalNotify())
          }
        }
      } else {
        yield put(saveHospitalNotify())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([HospitalNotifyConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
